import _classCallCheck from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { LATITUDE, LATITUDE2, LONGITUDE, LONGITUDE2 } from '../../channel';
import { isValueDef } from '../../channeldef';
import { duplicate } from '../../util';
import { DataFlowNode } from './dataflow';
export var GeoPointNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(GeoPointNode, _DataFlowNode);

  function GeoPointNode(parent, projection, fields, as) {
    var _this;

    _classCallCheck(this, GeoPointNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeoPointNode).call(this, parent));
    _this.projection = projection;
    _this.fields = fields;
    _this.as = as;
    return _this;
  }

  _createClass(GeoPointNode, [{
    key: "clone",
    value: function clone() {
      return new GeoPointNode(null, this.projection, duplicate(this.fields), duplicate(this.as));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return {
        type: 'geopoint',
        projection: this.projection,
        fields: this.fields,
        as: this.as
      };
    }
  }], [{
    key: "parseAll",
    value: function parseAll(parent, model) {
      if (!model.projectionName()) {
        return parent;
      }

      [[LONGITUDE, LATITUDE], [LONGITUDE2, LATITUDE2]].forEach(function (coordinates) {
        var pair = coordinates.map(function (channel) {
          return model.channelHasField(channel) ? model.fieldDef(channel).field : isValueDef(model.encoding[channel]) ? {
            expr: model.encoding[channel].value + ''
          } : undefined;
        });
        var suffix = coordinates[0] === LONGITUDE2 ? '2' : '';

        if (pair[0] || pair[1]) {
          parent = new GeoPointNode(parent, model.projectionName(), pair, [model.getName('x' + suffix), model.getName('y' + suffix)]);
        }
      });
      return parent;
    }
  }]);

  return GeoPointNode;
}(DataFlowNode);